import { render, staticRenderFns } from "./modal-box.vue?vue&type=template&id=08e5be39&scoped=true&"
import script from "./modal-box.vue?vue&type=script&lang=js&"
export * from "./modal-box.vue?vue&type=script&lang=js&"
import style0 from "./modal-box.vue?vue&type=style&index=0&id=08e5be39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e5be39",
  null
  
)

export default component.exports